
















import { computed, defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import type { Money } from 'types/commercetools';
import moneyToNumber from '~/helpers/commercetools/moneyToNumber';
import { useI18n } from '~/composables';
import { NET_PRICE_CUSTOM_FIELD_NAME, DEFAULT_MONEY_TYPE } from '~/constants/netPrice';
import type { ProductPrice } from '~/types/commercetools';

export default defineComponent({
  name: 'VatInfo',
  props: {
    isNetInvoiceEnabled: {
      type: Boolean,
      default: false,
    },
    vatPercentage: {
      type: Number,
      default: undefined,
    },
    productPrice: {
      type: Object as PropType<ProductPrice>,
      required: true,
    },
  },

  setup(props) {
    const { i18n } = useVSFContext();
    const { currencyCode } = useI18n();

    const netPrice = computed<Money|null>(() => {
      const rawNetPrice = props.productPrice?.custom?.customFieldsRaw?.find(
        field => field.name === NET_PRICE_CUSTOM_FIELD_NAME,
      )?.value;

      if (rawNetPrice) {
        const moneyNetPrice: Money = {
          centAmount: rawNetPrice?.centAmount,
          currencyCode: rawNetPrice?.currencyCode,
          type: rawNetPrice?.type || DEFAULT_MONEY_TYPE,
          fractionDigits: rawNetPrice?.fractionDigits,
        };

        return moneyNetPrice;
      }

      return null;
    });

    const netPriceInCurrency = computed<string|null>(() => {
      if (netPrice.value) {
        const formattedPrice = moneyToNumber(netPrice.value);

        const priceInCurrency = i18n.n(formattedPrice, {
          style: 'currency',
          currency: currencyCode.value,
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });

        return priceInCurrency;
      }

      return null;
    });

    return {
      netPriceInCurrency,
    };
  },
});

